import React from 'react';
import CircleButton from '../../shared/CircleButton';
import currLocIcon from '../../../../assets/images/icons/trail/icons-controls-nearby.svg';
import zoomInIcon from '../../../../assets/images/icons/trail/icons-controls-zoom-in.svg';
import zoomOutIcon from '../../../../assets/images/icons/trail/icons-controls-zoom-out.svg';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { wrapEventHandler } from '../../../utils/handlers';

const ZoomControls = ({ handleZoomInClick, handleZoomOutClick, handleCurrLocClick }) => {
  return (
    <>
      <CircleButton icon={zoomInIcon} onClick={wrapEventHandler(handleZoomInClick)} title={StringConstantsMixin.strings.SEARCH.ZOOM_IN} />
      <CircleButton icon={zoomOutIcon} onClick={wrapEventHandler(handleZoomOutClick)} title={StringConstantsMixin.strings.SEARCH.ZOOM_OUT} />
      <CircleButton icon={currLocIcon} onClick={wrapEventHandler(handleCurrLocClick)} title={StringConstantsMixin.strings.SEARCH.CURRENT_LOCATION} />
    </>
  );
};

export default ZoomControls;
